import addUserMarkupPopupEventListener from './addUserMarkupPopupEventListener';
import addHighlightId from '../actions/addHighlightId';
import { ClientItem } from 'owa-mail-store';
import markElements from 'owa-mark/lib/utils/markElements';
import parseMarkId from 'owa-mark/lib/utils/parseMarkId';
import { UNMARK_ELEMENT_LABEL } from 'owa-mark/lib/utils/constants';

const styles = require('../components/UserMarkupStyles.scss');

export default function markUserHighlight(
    element: HTMLElement,
    item: ClientItem,
    highlight: string
) {
    markElements(
        element,
        [highlight],
        (keyword: string) => (matchedElement: HTMLElement) => {
            // Ignore if there is already a note on this element (VSO 62047)
            if (!hasUserNoteAttached(matchedElement)) {
                markInstanceOfUserHighlight(matchedElement, item, keyword);
            } else {
                matchedElement.classList.add(UNMARK_ELEMENT_LABEL);
            }
        },
        false /* useRegExp */,
        'partially' /* accuracy */
    );
}

export function markInstanceOfUserHighlight(
    element: HTMLElement,
    item: ClientItem,
    highlight: string
) {
    element.classList.add(styles.userHighlight);

    // Highlights may span multiple elements on the DOM
    // Remember the whole highlight because the whole highlight should be removed
    // from the server if activated from any element (VSO20847)
    addHighlightId(parseMarkId(element.className), highlight);

    // When a new user highlight is made, bind an event to show a popup with the
    // options to remove the highlight, add a note, or reply with the selection
    addUserMarkupPopupEventListener(element, item, highlight, false /* isForExistingUserNote */);
}

function hasUserNoteAttached(element: HTMLElement): boolean {
    // Because of logic in the note-js library, the matched element will have
    // already been marked by the time this is called. If there was a previous
    // mark there, it will be this element's parent
    return element?.parentElement?.classList.contains(styles.userNote);
}
